import React, { FC, ReactElement } from 'react';

import { IImage, PayFitColor } from '../../types/module';

import { ButtonV2Props } from '../../../../growth-platform-brand-system-v2/src/components/ButtonV2';
import { textTitle3 } from '../../../../growth-platform-brand-system-v2/src/styles/typography';
import { classNames } from '../../../../growth-platform-brand-system-v2/src/utils/style';
import { applyBackgroundColor } from './logic';
import { useScreenSize } from '../../../../growth-platform-brand-system-v2/src/utils/utils';
import { Image } from '@payfit/growth-platform-brand-system-v2';

export interface BlogBannerProps {
  title: string;
  backgroundColor?: PayFitColor;
  image?: IImage;
  cta?: ReactElement<ButtonV2Props>;
}

export const BlogBanner: FC<BlogBannerProps> = ({
  image,
  backgroundColor = 'blue',
  title,
  cta,
}) => {
  const screenSize = useScreenSize();
  const isDesktop = !['xs', 'sm', 'md'].includes(screenSize);
  return (
    <div
      className={`BlogBanner ${applyBackgroundColor(
        backgroundColor,
      )} p-24 rounded-12 flex flex-col sm:flex-row banner`}
    >
      {image?.url && isDesktop && (
        <div className="mb-16 sm:mb-0  sm:mr-24 w-full sm:w-auto sm:max-w-1/2">
          <div
            className={
              'rounded-6 bg-blue-301 image-container max-w-full overflow-hidden'
            }
          >
            <Image
              loading="lazy"
              alt={image?.alt || ''}
              src={image?.url}
              height={image?.height || 200}
              width={image?.height || 64}
              sizes="64px"
              pixelDensity="image"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      )}
      <div
        className={`flex w-full ${
          image
            ? 'flex-col items-center sm:items-start sm:justify-center text-center sm:text-left'
            : 'flex-col sm:flex-row items-center sm:w-auto'
        }`}
      >
        <div
          className={classNames(
            textTitle3,
            `${image ? '' : 'flex-1'} text-center sm:text-left`,
          )}
        >
          {title}
        </div>
        {cta && (
          <div
            className={`${
              image
                ? 'mt-16 sm:mt-24 w-full'
                : 'w-full sm:w-auto sm:pl-48 mt-24 sm:mt-0'
            }`}
          >
            {cta}
          </div>
        )}
      </div>
    </div>
  );
};
